import React from 'react';
import styles from './InvitationButtons.module.sass';
import {
  INVITE_MEMBERS,
  PENDING_INVITATIONS,
  BACK_TO_SUMMARY,
  InviteStatus,
} from '../../../../../constants/teams.js';
import Plus from '../../../../../asset/teams/roster/invitations/Rectangle_plus.webp';
import useWindowDimensions from '../../../../../hooks/useWindowDimensions';
import { MOBILE_DIMENSION } from '../../../../../constants/const';
import { notifySeasonMembers } from '../../../../../api/teams-api';
import { message } from 'antd';

export function InvitationButtons({
  pendingInvitations,
  handlePendingInvitationButtonClick,
  setInviteStatus,
  currentTeamId,
  isManager,
}) {
  const { width } = useWindowDimensions();
  const handleNotifyButtonClick = () => {
    notifySeasonMembers(currentTeamId).then((response) => {
      response.json().then((data) => {
        if (data.isNotified) {
          message.success('Season members notified');
        } else {
          message.error('Failed to notify season members');
        }
      });
    });
  };
  return (
    <div className={styles.invitation_buttons}>
      <button
        onClick={handlePendingInvitationButtonClick}
        className={
          width >= MOBILE_DIMENSION
            ? styles.summary_invitations_toggler
            : styles.invite_members_button
        }
      >
        {pendingInvitations ? BACK_TO_SUMMARY : PENDING_INVITATIONS}
      </button>
      <button
        className={
          width >= MOBILE_DIMENSION
            ? styles.summary_invitations_toggler
            : styles.invite_members_button
        }
        onClick={() => setInviteStatus(InviteStatus.SEND_INVITE)}
      >
        {/* <img className={styles.invite_members_button__image} src={Plus} alt="" /> */}
        {INVITE_MEMBERS}
      </button>
      {isManager && (
        <button
          className={
            width >= MOBILE_DIMENSION
              ? styles.summary_invitations_toggler
              : styles.invite_members_button
          }
          onClick={handleNotifyButtonClick}
        >
          {/* <img className={styles.invite_members_button__image} src={Plus} alt="" /> */}
          Email Season Goal
        </button>
      )}
    </div>
  );
}
